/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { ProjectType } from '@modules/ui-types/projects'
import type { ProjectID } from '@modules/project-user-api/v1/types'

export type RouterProjectType = ProjectType | ':projectType' // for route-matching purposes

export function projectsUrl(): string {
  return `/projects`
}

export function projectUrl(projectType: RouterProjectType, projectId: ProjectID): string {
  return `${projectsUrl()}/${projectType}/${projectId}`
}
